import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/tr'

dayjs.extend(relativeTime)
dayjs.locale('tr')

export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B'
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  const value = bytes / Math.pow(1024, i)
  return `${value.toFixed(i === 0 ? 0 : 1)} ${units[i]}`
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  return dayjs(iso).format('D MMMM YYYY, HH:mm')
}

export function formatDateShort(iso: string | null | undefined): string {
  if (!iso) return '—'
  return dayjs(iso).format('D MMM YYYY')
}

/** "3 saat önce" — bir haftadan eskiyse tam tarih. */
export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = dayjs(iso)
  return dayjs().diff(d, 'day') > 7 ? d.format('D MMM YYYY') : d.fromNow()
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toLocaleUpperCase('tr-TR') ?? '')
    .join('')
}

/**
 * IP adresini ekranda kısa yazımıyla gösterir (RFC 5952).
 *
 * <p>Java IPv6'yı sıkıştırmadan döndürüyor: yerel makine
 * {@code 0:0:0:0:0:0:0:1} olarak geliyor ve denetim tablosunun dar IP
 * sütununda iki satıra taşıyordu. En uzun sıfır grubu dizisi {@code ::}
 * olur, baştaki sıfırlar atılır; yerel makine {@code ::1} görünür.
 * IPv4 ve tanınmayan değerler olduğu gibi döner.
 */
export function kisaIp(ip: string | null | undefined): string {
  if (!ip) return '—'
  if (!ip.includes(':') || ip.includes('::')) return ip.toLowerCase()

  const gruplar = ip.toLowerCase().split(':')
  if (gruplar.length !== 8 || gruplar.some((g) => !/^[0-9a-f]{1,4}$/.test(g))) return ip

  const kisa = gruplar.map((g) => g.replace(/^0+(?=.)/, ''))
  // En uzun ardışık "0" dizisi; eşitlikte ilki. Tek sıfır grubu sıkıştırılmaz.
  let enIyiBas = -1, enIyiUzun = 1
  for (let i = 0; i < 8; ) {
    if (kisa[i] !== '0') { i++; continue }
    let j = i
    while (j < 8 && kisa[j] === '0') j++
    if (j - i > enIyiUzun) { enIyiBas = i; enIyiUzun = j - i }
    i = j
  }
  if (enIyiBas < 0) return kisa.join(':')
  return `${kisa.slice(0, enIyiBas).join(':')}::${kisa.slice(enIyiBas + enIyiUzun).join(':')}`
}
